// Active Projects summary on the dashboard: the next few big rocks by
// due date with progress pills. Real data from /api/data/projects.

import { Link } from 'react-router-dom';
import { useMarketing } from '../MarketingContext';
import { Card, Eyebrow, Pill } from '../ui';
import { parseLocalDate } from '../dates';
import { PROJECT_STATUS } from '../screens/ProjectsView';

export default function ProjectsSummaryCard() {
  const { projects } = useMarketing();
  const active = (projects.data || [])
    .filter(p => p.status !== 'done')
    .slice(0, 4);

  return (
    // flex-[1.15] mirrors ThisWeekCard above so the two rows' column
    // boundaries line up.
    <Card lash="teal" className="p-4 flex-[1.15]">
      <div className="flex items-center justify-between mb-3">
        <Eyebrow>Active projects</Eyebrow>
        <Link to="/marketing/projects" className="text-bullogic-blue text-[12px] font-bold">
          All projects →
        </Link>
      </div>

      {projects.loading && <div className="text-[12px] text-ink-3">Loading…</div>}

      {!projects.loading && active.length === 0 && (
        <div className="text-[13px] text-ink-2">
          No active projects. Add the big rocks (lead magnet builds, quarter planning,
          template refreshes) from the Projects screen.
        </div>
      )}

      <div className="flex flex-col gap-2.5">
        {active.map(p => {
          const st = PROJECT_STATUS[p.status] || PROJECT_STATUS.not_started;
          const started = p.steps.length > 0 && p.progress > 0;
          return (
            <div key={p.id} className="flex items-center justify-between gap-3">
              <div className="min-w-0">
                <b className="text-navy text-[13px] block truncate">{p.name}</b>
                <div className="text-ink-2 text-[12px] truncate">
                  {[p.synopsis, p.dueDate ? `due ${parseLocalDate(p.dueDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}` : null]
                    .filter(Boolean).join(' · ')}
                </div>
              </div>
              <Pill tone={started ? 'neutral' : st.tone} className="shrink-0">
                {started ? `${Math.round(p.progress * 100)}%` : st.label}
              </Pill>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
